import { GtxWordmark, LogoLink } from './Header.styles.tsx';

export const Logo = () => (
  <LogoLink to="/" aria-label="G.Tx home">
    <GtxWordmark aria-hidden>
      G<span className="gtx-dot">.</span>Tx
    </GtxWordmark>
  </LogoLink>
);
